module.exports = __webpack_public_path__ + "static/media/1.7f983f55.mp4";